import { ReactNode } from 'react';
import PageBackButton from 'components/PageBackButton';

interface PageHeroProps {
  eyebrow: string;
  title: string;
  description?: string;
  descriptionClassName?: string;
  icon?: ReactNode;
  aside?: ReactNode;
  /** Show back control inside the felt hero (default on for all layout pages). */
  showBack?: boolean;
}

export default function PageHero({
  eyebrow,
  title,
  description,
  descriptionClassName,
  icon,
  aside,
  showBack = true,
}: PageHeroProps) {
  return (
    <section className="game-home-felt relative overflow-hidden rounded-2xl p-5 sm:p-7">
      <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-tp-gold/10 blur-3xl" />
      {showBack ? (
        <div className="page-hero-back-row relative z-10 mb-4">
          <PageBackButton className="page-hero-back-btn" />
        </div>
      ) : null}
      <div className="relative z-10 flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 text-emerald-400/90">
            {icon}
            <span className="text-[10px] font-bold uppercase tracking-[0.35em]">{eyebrow}</span>
          </div>
          <h1 className="mt-2 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            {title}
          </h1>
          {description && (
            <p className={`mt-2 max-w-xl text-sm leading-relaxed text-white/55 ${descriptionClassName ?? ''}`}>
              {description}
            </p>
          )}
        </div>
        {aside && <div className="shrink-0">{aside}</div>}
      </div>
    </section>
  );
}
